import * as React from 'react'

import { PricingPriceBlock } from 'Pages/Pricing/@components'


export default function discountColumn(label) {
    return {
        name: 'price', label: label,
        options: {
			headerAlign: 'left',
			setCellHeaderProps: () => ({ sx: { whiteSpace: 'pre-wrap' } }),
            customBodyRowRenderLite: (value, { currency, discount }) => <PricingPriceBlock
				price={value}
				currency={currency}
				diff={discount}
				propsTypography={{ variant: "caption", sx: { fontSize: 11, ml: .5 } }}
				reverse
			/>
        }
    }
}